import React, { useState, useRef, useLayoutEffect } from 'react';
import { createPortal } from 'react-dom';
import './ScoreInfoButton.css';

const VIEWPORT_PADDING = 12;

const ScoreInfoButton = ({ text, onClick }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [anchorRect, setAnchorRect] = useState(null);
  const [tooltipStyle, setTooltipStyle] = useState(null);
  const tooltipRef = useRef(null);

  const showTooltip = (event) => {
    setAnchorRect(event.currentTarget.getBoundingClientRect());
    setTooltipStyle(null);
    setIsVisible(true);
  };

  const hideTooltip = () => {
    setIsVisible(false);
    setAnchorRect(null);
    setTooltipStyle(null);
  };

  useLayoutEffect(() => {
    if (!isVisible || !anchorRect || !tooltipRef.current) return;

    const tooltip = tooltipRef.current;
    const { width } = tooltip.getBoundingClientRect();
    const anchorCenterX = anchorRect.left + anchorRect.width / 2;

    const halfWidth = width / 2;
    const minCenter = VIEWPORT_PADDING + halfWidth;
    const maxCenter = window.innerWidth - VIEWPORT_PADDING - halfWidth;

    const left = Math.min(Math.max(anchorCenterX, minCenter), maxCenter);
    const arrowOffset = anchorCenterX - left;

    setTooltipStyle({
      top: anchorRect.top,
      left,
      '--arrow-offset': `${arrowOffset}px`,
    });
  }, [isVisible, anchorRect, text]);

  return (
    <span
      className="score-info-button-wrap"
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
    >
      <button
        type="button"
        className="info-button"
        onClick={(e) => {
          e.stopPropagation();
          onClick?.(e);
        }}
        aria-label={text}
      >
        ?
      </button>

      {isVisible &&
        createPortal(
          <span
            ref={tooltipRef}
            className="score-info-tooltip"
            role="tooltip"
            style={
              tooltipStyle || {
                top: anchorRect?.top ?? 0,
                left: anchorRect
                  ? anchorRect.left + anchorRect.width / 2
                  : 0,
                visibility: 'hidden',
              }
            }
          >
            {text}
          </span>,
          document.body
        )}
    </span>
  );
};

export default ScoreInfoButton;
